import React from 'react'
import { connect } from 'react-redux'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@mui/material'
import LoginForm from '../modules/LoginForm'
import { dialogClose } from '../system/redux/reducers/dialog'
import { getMessage } from '../helpers/Messages'

const Dialogs = ({ dispatch, dialog }) => {
    return (
        <>
            <Dialog open={dialog.id === 'LOGIN' && dialog.open} onClose={() => dispatch(dialogClose())}>
                <DialogTitle>Login</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {getMessage('loginRequired')}
                    </DialogContentText>
                    <LoginForm />
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between' }}>
                    <Button onClick={() => dispatch(dialogClose())}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
function mapStateToProps(state) {
    return {
        dialog: state.Dialog,
    }
}
export default connect(mapStateToProps)(Dialogs)
